import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { GET_BARCODE } from '../../../../graphql/profile/queries';
import { IBarcodeData } from '../../../../graphql/profile/models/get-barcode.models';
import { setMyAcuvueId } from '../../../../graphql/configuration/configuration.cache';

export const MyAcuvueId = (): JSX.Element => {
  const { data } = useQuery<IBarcodeData>(GET_BARCODE);

  useEffect(() => {
    if (data?.profile?.myAcuvueId) {
      setMyAcuvueId(data.profile.myAcuvueId);
    }
  }, [data]);

  return <></>;
};
